import {Component} from 'react';
import {
    Link
  } from "react-router-dom";
import "./SharedComponents/sharedComponentsMedia.css";
import "./SharedComponents/sharedComponents.css";

class LinkCard extends Component {
    constructor(props) {
        super(props);
        this.state={

        }
    }

setSizeValues(){
    this.screenOK = true;
    this.initialClassValue = "card mt-4 mr-5 rounded-corners link-card";
    this.cardImgClassValue = "card-img-top";
    this.textClass = "text-center primary-blue linkCard-text";
    if (this.props.upSize === true){
        this.initialClassValue = "card mt-4 mr-5 rounded-corners-upSize link-card-upSize";
        this.cardImgClassValue = "card-img-top-upSize";
        this.textClass = "text-center primary-blue linkCard-text-upSize";
    }
    if (this.props.name.length <= 15){
          this.cardTextClassValue = "card-body p-2"
    }else{
          this.cardTextClassValue = "card-body p-0"
    }
 }   

    render() {
        this.setSizeValues();
    return <>
            <div className={this.initialClassValue}>
                {this.props.destination ?
                    <Link to = 
                    { this.props.allowed === false && this.screenOK ?
                            this.doNothing()
                    :
                        (this.props.allowed  && this.screenOK ?
                            this.props.destination
                        :
                            this.doNothing
                        )
                    }
                       onClick=
                            {this.props.allowed === false || this.screenOK === false ?
                                () => this.displayDeniedWarning()
                            :
                                this.doNothing()
                            }>
                    <img className={this.cardImgClassValue} src={this.props.imgSrc} alt="Card cap" />
                        <div className={this.cardTextClassValue}>
                            <h5 className={this.textClass}>{this.props.name}</h5>
                        </div>
                    </Link>
                :
                    <div>
                        <img className={this.cardImgClassValue} src={this.props.imgSrc} alt="Card cap" />
                        <div className={this.cardTextClassValue}>
                            <h5 className={this.textClass}>{this.props.name}</h5>
                        </div>
                    </div>
                }
            </div>
        </>
    }

    displayDeniedWarning(){
        if (this.props.allowed === false)
        {
            this.props.openLoginMenu();
        }else{
            alert ("Screen Size is too small to play this game.")
        }
    }

    doNothing()
    {}
}
export default LinkCard;